import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.test.js";
// 正则
export var regEmail = /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;
export var regPhone = /^1[3456789]\d{9}$/;
export var regPwd = /^.{6,18}$/;
export var regCode = /^[0-9]{6}$/;
export var regPicCode = /^[0-9a-zA-Z]{5}$/;
export var regBankNo = /^([0-9]{1})(\d{9,29})$/;
export var regId = /(^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$)|(^[1-9]\d{5}\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{2}$)/;
export var regLicense = /(^(?:(?![IOZSV])[\dA-Z]){2}\d{6}(?:(?![IOZSV])[\dA-Z]){10}$)|(^\d{15}$)/;
export var regBlankSpace = /\s+/g;
export var regUrl = /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\*\+,;=.]+$/;
export function validEmail(val) {
  return regEmail.test(val);
}
export function validPhone(val) {
  return regPhone.test(val);
}
export function validPass(val) {
  return regPwd.test(val);
}
export function validUserName(name) {
  return validPhone(name);
}
export function validCode(val) {
  return regCode.test(val);
}
export function validPostcode(val) {
  return regCode.test(val);
}
export function validPicCode(val) {
  return regPicCode.test(val);
}
export function validBankNo(val) {
  return regBankNo.test(val);
}
export function validId(val) {
  return regId.test(val);
}
export function validLicense(val) {
  return regLicense.test(val);
}
export function validBlankSpace(val) {
  return !regBlankSpace.test(val);
}
export function validUrl(val) {
  return regUrl.test(val);
}